import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { hasILRImageSelector } from '../../layout/selectors/layout.selectors';
import { NoisePlot } from '../../plot/components/NoisePlot';
import { RawSignalView } from '../../raw-signal/components/RawSignalView';
import { rawSignalLeadNamesSelector } from '../../raw-signal/selectors/raw-signal.selectors';
import { Resting } from '../../resting/Resting';
import { HrPlot } from '../components/HrPlot';
import { ILRPlot } from '../components/ILRPlot';
import { QrsAnnotation } from '../components/QrsAnnotation';
import { ViewPicker } from '../components/ViewPicker';
import { isRestingStripSelector } from '../selectors/ecg.selectors';
import { ZoomNoisePlot } from '../../plot/components/ZoomNoisePlot';

export const useRoutes = () => {
  const hasILRImage = useSelector(hasILRImageSelector);
  const leadNames = useSelector(rawSignalLeadNamesSelector);
  const isRestingStrip = useSelector(isRestingStripSelector);

  const routes = [
    <Route key='hr' path='/hr' element={<HrPlot />} />,
    <Route key='noise' path='/noise' element={<NoisePlot />} />,
    <Route key='zoom-noise' path='/zoom-noise' element={<ZoomNoisePlot />} />,
    <Route key='zoom' path='/zoom' element={<QrsAnnotation />} />,
    <Route key='default' path='*' element={<ViewPicker />} />,
  ];

  if (leadNames.length !== 0) {
    routes.push(<Route key='raw' path='/raw' element={<RawSignalView />} />);
  }

  if (isRestingStrip) {
    routes.push(<Route key='resting' path='/resting' element={<Resting />} />);
  }

  if (hasILRImage) {
    routes.push(<Route key='ilr' path='/ilr' element={<ILRPlot />} />);
  }

  return routes;
};
